<div
  class="header h-[55px] flex justify-between items-center p-[50px] !bg-[#DEE2E6] sticky z-50 top-0"
>
  <div class="flex items-center">
    <p class="!m-0">{{ labels.title }}</p>
    <p
      class="!mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px]"
    >
      Construction Work
    </p>
  </div>
  <div>
    <mat-icon class="cursor-pointer" (click)="closeModalEvent.emit()"
      >close</mat-icon
    >
  </div>
</div>
<form [formGroup]="form">
  <div
    class="!px-[30px] !mt-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2"
  >
    <span class="label"> Site Preparation</span>
    <app-rich-textEditor
      (contentChange)="setSitePreparation($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('site_preparation_control')?.value"
      [placeHolder]="'Site Preparation'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('site_preparation_control')?.touched &&
        form.get('site_preparation_control')?.invalid
      "
      class="error"
    >
      Site preparation is required
    </div>

    <app-file-manager
      [newFileControlName]="'sitePreparationFileControl'"
      [oldFiles]="oldSitePreparationFiles"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
      (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
    ></app-file-manager>
    <div
      *ngIf="
        form.get('site_preparation_file_control')?.touched &&
        form.get('site_preparation_file_control')?.invalid
      "
      class="error"
    >
      At least one attachment is required.
    </div>

    <span class="label mt-[14px]"> Structural and Civil Works</span>
    <app-rich-textEditor
      (contentChange)="setStructuralCivilWorks($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('civil_works_control')?.value"
      [placeHolder]="'Structural and Civil Works'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('civil_works_control')?.touched &&
        form.get('civil_works_control')?.invalid
      "
      class="error"
    >
      Structural and civil works is required
    </div>

    <div class="">
      <app-file-manager
        [newFileControlName]="'structureCivilFileControl'"
        [oldFiles]="oldStructureCivilFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label mt-[14px]"> MEP Works </span>
    <app-rich-textEditor
      (contentChange)="setMEPWorks($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('mep_works_control')?.value"
      [placeHolder]="'MEP Works'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('mep_works_control')?.touched &&
        form.get('mep_works_control')?.invalid
      "
      class="error"
    >
      MEP works is required
    </div>
    <app-file-manager
      [newFileControlName]="'mEPFileControl'"
      [oldFiles]="oldMEPFiles"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
      (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
    ></app-file-manager>

    <span class="label"> Finishing and Fit-Out</span>
    <app-rich-textEditor
      (contentChange)="setFitOut($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('fit_out_control')?.value"
      [placeHolder]="'Finishing and Fit-Out'"
    ></app-rich-textEditor>

    <div
      *ngIf="
        form.get('fit_out_control')?.touched &&
        form.get('fit_out_control')?.invalid
      "
      class="error"
    >
      Finishing and fit-out is required
    </div>
    <app-file-manager
      [newFileControlName]="'fitOutFileControl'"
      [oldFiles]="oldFitOutFiles"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
      (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
    ></app-file-manager>

    <span class="label"> Health & Safety Compliance</span>
    <app-rich-textEditor
      (contentChange)="setHealthSafetyCompliance($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('health_safety_control')?.value"
      [placeHolder]="'Health & Safety Compliance'"
    ></app-rich-textEditor>

    <div
      *ngIf="
        form.get('health_safety_control')?.touched &&
        form.get('health_safety_control')?.invalid
      "
      class="error"
    >
      Health & safety compliance is required
    </div>

    <app-file-manager
      [newFileControlName]="'healthSafetyFileControl'"
      [oldFiles]="oldHealthSafetyFiles"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
      (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
    ></app-file-manager>

    <span class="label mt-[14px]"> Post-Construction Activities</span>
    <app-rich-textEditor
      (contentChange)="setPostConstruction($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('post_construction_control')?.value"
      [placeHolder]="'Post-Construction Activities'"
    ></app-rich-textEditor>
    <div
      *ngIf="
        form.get('post_construction_control')?.touched &&
        form.get('post_construction_control')?.invalid
      "
      class="error"
    >
      Post-construction activities is required
    </div>
    <app-file-manager
      [newFileControlName]="'postConstructionFileControl'"
      [oldFiles]="oldPostConstructionFiles"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
      (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
    ></app-file-manager>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
